import { render, staticRenderFns } from "./price-slider.vue?vue&type=template&id=354e8e52&scoped=true&"
import script from "./price-slider.vue?vue&type=script&lang=js&"
export * from "./price-slider.vue?vue&type=script&lang=js&"
import style0 from "./price-slider.vue?vue&type=style&index=0&id=354e8e52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354e8e52",
  null
  
)

export default component.exports